// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"245":"d3cdd735","498":"e9632639"}[chunkId] + ".chunk.js";
};